import IdListDTO from './IdListDTO';

export default class GroupDTO {
  groupId: string;

  /** The directory's own id of the group; the server derives groupId from it for a non-Entra organization. */
  providerGroupId?: string;

  identityProviderType?: number;

  name: string;

  email: string;

  syncEnabled: boolean;

  syncStatus?: number;

  syncError?: string;

  syncMemberCount?: number;

  taskFilterEnabled?: boolean;

  userIds?: IdListDTO;

  constructor(_groupId?: string, _name?: string, _email?: string) {
    this.groupId = _groupId ? _groupId : '';
    this.name = _name ? _name : '';
    this.email = _email ? _email : '';
    this.syncEnabled = false;
  }
}
